import {useCallback} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {PaginatedResponseV2} from "../../../types/PaginatedResponse";
import {SirenAlert} from "../typedefs";

export function useGetSirenAlerts(clientID: string | null) {
    return useCallback(async (search: string, page: number): Promise<PaginatedResponseV2<SirenAlert> | null> => {
        const res = await platformAPI.get<PaginatedResponseV2<SirenAlert>>("api/siren/alerts", {
            params: {page, limit: 20, search, ...(clientID ? {clientID} : {})}
        })
        const {results, hasMore, currentPage} = res.data
        return {results, hasMore, currentPage}
    }, [clientID])
}
